module.exports = __webpack_public_path__ + "static/media/dcdb-burger-en.584cf8da.jpg";